import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[SW] App cached for offline use.');
  },
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('sw:update', { detail: registration }));
    // In development, auto-reload immediately when a new SW activates so stale
    // cached bundles never block the dev server's fresh code.
    if (process.env.NODE_ENV !== 'production') {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});
